import Colour from '@components/ui/Colour'
import cn from 'clsx'
import { FC, useEffect, useState } from 'react'
import { connectRefinementList } from 'react-instantsearch-dom'
import { sortBy } from 'lodash'

interface refinementListProps {
  items: any[]
  currentRefinement: string[]
  refine: any
  createURL: any
  title?: string
  className?: string
  attribute: string
  hasOptions: (a: string, b: boolean) => void
}

const mapColorCode = (label: string) => {
  // Demo color display. Subject to change.
  if (label.includes('gold')) return '#D3BA86'
  if (label.includes('silver')) return '#CECECE'
  return null
}

const RefinementList: FC<refinementListProps> = ({
  items,
  refine,
  className,
  attribute,
  hasOptions,
}) => {
  if (items.length <= 1) {
    hasOptions && hasOptions(attribute, false)
    return <></>
  }

  hasOptions && hasOptions(attribute, true)

  return <>
    <div className="lg:max-w-175">
      <div
        className={`flex flex-wrap lg:justify-center gap-2 lg:gap-4 ${className}`}
      >
        {items?.map((item: any, index: any) => {
          let itemName = item?.label?.replace(/_/g, ' ')
          let colourHex =
            attribute === 'named_tags.Material'
              ? mapColorCode(itemName)
              : null
          return (
            <div
              key={index}
              className={cn('ais-RefinementList-item', {
                'ais-RefinementList-item--selected ': item.isRefined,
              })}
              onClick={(event) => {
                event.preventDefault()
                refine(item.value)
              }}
            >
              <div className="ais-RefinementList-label  cursor-pointer">
                {colourHex && (
                  <div className="flex items-center gap-3 pr-4 bg-ui-lightest-grey h-10 px-3 rounded text-body2 ">
                    <Colour colour={colourHex} />
                    {itemName}
                  </div>
                )}
                {!colourHex && (
                  <div className="flex items-center  bg-ui-lightest-grey h-10 px-4  rounded text-body2 ">
                    {itemName}
                  </div>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  </>;
}

const CustomRefinementList = connectRefinementList(RefinementList)

export default CustomRefinementList
